module.exports = __webpack_public_path__ + "img/icon-91.46906377.png";